export const SHUTDOWN_MODE = true;
